import * as React from 'react';
import styles from './option-color.scss';
import { toHex } from 'ui/common/hex-converter';

export interface OptionColorProps {
  color: number;
}

export const OptionColor = ({ color }: OptionColorProps) =>
  <div className={styles.optionColorContainer}>
    <div className={styles.optionColorContentCentered}>
      <div className={styles.optionColor} style={{ backgroundColor: color === 0 ? 'rgb(0, 0, 0)' : toHex(color) }} />
    </div>
  </div>;
